<template>
  <div id="May2023" class="202305">
    <div class="fixed z-50 hidden xl:block" :class="{ 'fixed-btn': isMenu, 'hidden-btn': !isMenu}">
      <a class="toggle-btn absolute cursor-pointer p-6 block" @click="isMenu = !isMenu">
        <img src="~@/assets/images/202305/menu/right.png" class="object-contain w-full">
      </a>
      <a class="cursor-default block px-3"><img src="~@/assets/images/202305/menu/menu-bar-off_01.png" class="object-contain"></a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#section2')">
        <img src="~@/assets/images/202305/menu/menu-bar-off_02.png" class="off object-contain">
        <img src="~@/assets/images/202305/menu/menu-bar-on_02.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#section3')">
        <img src="~@/assets/images/202305/menu/menu-bar-off_03.png" class="off object-contain">
        <img src="~@/assets/images/202305/menu/menu-bar-on_03.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#section4')">
        <img src="~@/assets/images/202305/menu/menu-bar-off_04.png" class="off object-contain">
        <img src="~@/assets/images/202305/menu/menu-bar-on_04.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#May2023')">
        <img src="~@/assets/images/202305/menu/menu-bar-off_05.png" class="off object-contain">
        <img src="~@/assets/images/202305/menu/menu-bar-on_05.png" class="on object-contain">
      </a>
    </div>
    <main class="main mx-auto">
      <section id="section1" class="section1 main-red-bg px-2">
        <div class="container">

          <div class="flex items-center justify-center relative pt-16">
            <div class="absolute circle"><img src="~@/assets/images/202305/circle.png" class="object-contain block"></div>
            <div class="hidden md:flex flex-col items-center justify-center z-10">
              <div><img src="~@/assets/images/202305/DATE-01.png" class="object-contain block"></div>
              <div><img src="~@/assets/images/202305/buger+mg.png" class="object-contain block"></div>
            </div>
            <div class="md:hidden flex-col items-center justify-center z-10 mb-3">
              <div class="z-10"><img src="~@/assets/images/202305/m/master-m.png" class="object-contain block"></div>
            </div>
            <div class="hidden md:block z-10"><img src="~@/assets/images/202305/photo-01.png" class="object-contain block"></div>
          </div>
          <div class="flex justify-center z-10">
            <div class="z-10"><img src="~@/assets/images/202305/plan-01.png" class="object-contain hidden md:block"></div>
            <div class="z-10"><img src="~@/assets/images/202305/m/plan-m.png" class="object-contain block md:hidden"></div>
          </div>
        </div>

      </section>

      <section id="section2" class="bg-white px-4 py-12 xl:py-16 container">
        <div class="hidden md:block"><img src="~@/assets/images/202305/title-01.png" class="object-contain block"></div>
        <div class="md:hidden"><img src="~@/assets/images/202305/m/magazine-info-m.png" class="object-contain block mx-auto"></div>

        <div class="flex pt-3 lg:pt-6 lg:px-8 flex-col md:flex-row">
          <div class="flex items-center flex-wrap w-full md:w-7/12">
            <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="p-2 lg:p-5 w-1/2 md:w-1/3" v-for="(item, index) in planData" :key="index">
              <img :src="item.img_url" class="object-contain">

              <p class="text-xs mb-1">{{ item.grade }}</p>
              <p class="text-lg font-black">{{ item.title }}</p>
            </router-link>
          </div>

          <div class="w-full md:w-5/12 pt-6 md:px-3 xl:px-8 hidden md:block">
            <a href="https://store.liveabc.com/products/magazine/sale?tag=245" class="block">
              <p class="font-black leading-loose text-lg xl:text-xl">全系列雜誌１０期（６刊選１）<br/>+ 麥香鷄堡套餐組合</p>

              <p class="mb-3">$<span class="text-5xl mx-2 font-black main-red-color">1,680</span> <span>原價</span><span class="line-through">$2287</span> </p>

              <div class="mb-3"><img src="~@/assets/images/202305/order-button-yellow.png" class="object-contain block"></div>

              <p class="leading-loose">注意事項 : 香雞堡套餐組合內容為「麥當勞麥香鷄+中杯可樂」，為LiveABC向Ticket Xpress即享券企業禮贈平台購買之「麥當勞麥香鷄+中杯可樂即享券」，將於2023.6.7前統一以簡訊方式寄出。</p>
            </a>
          </div>
        </div>

        <div class="justify-end mt-6 lg:-mt-6 xl:-mt-40 px-8 hidden md:flex">
          <div class="border-b-4 border-red-700 flex-1"></div>
          <div class="w-1/3"><img src="~@/assets/images/202305/photo-02.png" class="object-contain block"></div>
        </div>

      </section>

      <section id="section3" class="p-4 container">
        <a href="https://store.liveabc.com/book/detail/6743" class="block">
          <div class="hidden md:block py-8">
            <div><img src="~@/assets/images/202305/title-02.png" class="object-contain block"></div>
            <div><img src="~@/assets/images/202305/livepen-order.png" class="object-contain block"></div>
          </div>
          <div class="md:hidden main-red-yellow2 py-12">
            <div><img src="~@/assets/images/202305/m/livepen-info-m.png" class="object-contain block mx-auto"></div>
            <div class="mt-4"><img src="~@/assets/images/202305/m/livepen-photo-m.png" class="object-contain block mx-auto"></div>
          </div>
        </a>
      </section>

      <section id="section4" class="bg-white p-4 py-8 container">
        <div class="hidden md:block"><img src="~@/assets/images/202305/title-03.png" class="object-contain block"></div>
        <div class="hidden md:block"><img src="~@/assets/images/202305/title-03-1(pocket).png" class="object-contain block"></div>
        <div class="flex md:hidden mb-6 items-center">
          <div class="font-semibold flex-1">
            <h6 class="text-2xl mb-2">單書任選４本69折</h6>
            <h6 class="text-sm">口袋書系列｜學習帶著走</h6>
          </div>
          <div class="md:hidden"><img src="~@/assets/images/202305/m/photo-3-m.png" class="object-contain block"></div>
        </div>
        <div class="flex flex-wrap">
          <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="item w-1/2 lg:w-1/4 p-2 md:p-4 cursor-pointer" v-for="(item, idx) in bookData" :key="idx">

            <div class="bg-white h-full flex flex-col justify-between mb-3" v-if="renderComponent">
              <div class="item relative main-red-pink py-6 md:rounded">
                <div class="outer mb-2">
                  <div class="inner mx-auto border-0 absolute w-full h-full">
                    <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!item.cover">
                    <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else>
                  </div>
                </div>
              </div>

              <div class="price event_text tracking-wider font-semibold">
                <p class="font-semibold text-sm md:text-base">{{ item.text }}</p>
                <div class="border-b border-dotted my-2 md:my-3"></div>
                <p>69折特價 $<span class="main-red-color text-2xl">{{ Math.round(Number.parseFloat(item.fixed_price * 0.69).toFixed(1)) }}</span></p>
              </div>
            </div>
          </router-link>
        </div>

        <a href="https://store.liveabc.com/products/magazine/sale?tag=248" class="mx-auto mt-6 hidden md:block"><img src="~@/assets/images/202305/more.png" class="object-contain block mx-auto"></a>

        <div class="hidden md:block"><img src="~@/assets/images/202305/title-03-2(biz).png" class="object-contain block"></div>
        <div class="flex md:hidden my-6 items-center">
          <div class="font-semibold flex-1">
            <h6>社會新鮮人系列｜職場必備語言技能</h6>
          </div>
          <div class="md:hidden"><img src="~@/assets/images/202305/m/photo-4-m.png" class="object-contain block"></div>
        </div>

        <div class="flex flex-wrap">
          <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="item w-1/2 lg:w-1/4 p-2 md:p-4 cursor-pointer" v-for="(item, idx) in bookData2" :key="idx">

            <div class="bg-white rounded-lg h-full flex flex-col justify-between mb-3" v-if="renderComponent">
              <div class="item relative main-red-yellow py-6 rounded">
                <div class="outer mb-2">
                  <div class="inner mx-auto border-0 absolute w-full h-full">
                    <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!item.cover">
                    <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else>
                  </div>
                </div>
              </div>

              <div class="price event_text tracking-wider font-semibold">
                <p class="font-semibold text-sm md:text-base">{{ item.text }}</p>
                <div class="border-b border-dotted my-3"></div>
                <p>69折特價 $<span class="main-red-color text-2xl">{{ Math.round(Number.parseFloat(item.fixed_price * 0.69).toFixed(1)) }}</span></p>
              </div>
            </div>
          </router-link>
        </div>

        <a href="https://store.liveabc.com/products/magazine/sale?tag=247" class="block mx-auto mt-6"><img src="~@/assets/images/202305/more.png" class="object-contain block mx-auto"></a>
      </section>

      <section class="event_text py-6 pb-10 main-text-color text-shadow container">
        <div class="container px-4 pl-8">
          <h6 class="text-xl lg:text-2xl mb-4 font-semibold">注意事項</h6>
          <ul class="list-decimal list-outside leading-loose text-base">
            <li>凡於活動期間2023.5.1~5.31內，官網消費單筆訂單滿2,500元，就送「21世紀情境式英語圖解字典(精裝擴編版)」，贈品數量有限，送完為止。</li>
            <li>訂閱『全系列雜誌10期(６刊選１)+麥香鷄雞堡套餐組合』之訂戶，其票券為LiveABC向Ticket Xpress即享券企業禮贈平台購買之「麥當勞麥香鷄+中杯可樂即享券」，將於2023.6.7前統一以簡訊方式寄出。</li>
            <li>本公司保留替換其他等值獎項及變更、修改本活動之權利。</li>
            <li>活動以官網公告為主，凡有變更則不另加通知。</li>
          </ul>
        </div>
      </section>
    </main>
  </div>
</template>
<script>
import jump from 'jump.js'
import axios from 'axios'
export default {
  name: 'May2023',
  metaInfo () {
    return {
      title: '訂雜誌 學英語 LiveABC請你吃漢堡! 精打細算全攻略 繳稅季不用吃土了',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: false,
      renderComponent: false,
      planData: [
        { name: 'ABC', id: 8561, grade: '初級 / 基礎 / 活用', title: 'ABC互動英語', type: 'abc', img_url: require('@/assets/images/202305/ABC-COVER.png') },
        { name: 'LIVE', id: 8562, grade: '中級 / 生活 / 實用', title: 'Live互動英語', img_url: require('@/assets/images/202305/LIVE-COVER.png') },
        { name: 'ALL', id: 8400, grade: '中高級 / 進階 / 應用', title: 'ALL+互動英語', img_url: require('@/assets/images/202305/ALL-COVER.png') },
        { name: 'CNN', id: 8563, grade: '新聞 / 時事 / 新知', title: 'CNN互動英語', type: 'cnn', img_url: require('@/assets/images/202305/CNN-COVER.png') },
        { name: 'JP', id: 8564, grade: '初級 / 生活 / 實用', title: '互動日本語', type: 'jp', img_url: require('@/assets/images/202305/JP-COVER.png') },
        { name: 'HW', id: 8566, grade: '科普/ 圖像 / 百科', title: '知識大圖解', type: 'hiw', img_url: require('@/assets/images/202305/HIW-COVER.png') }
      ],

      bookData: [
        { id: 8313, text: '多益必考單字全都背起來' },
        { id: 7434, text: '快速Get新聞重點單字' },
        { id: 7161, text: '閱讀是英語學習的基礎' },
        { id: 7002, text: '網路社群用語快學起來' },
        { id: 7013, text: '理解英語片語用法' },
        { id: 6521, text: '生活中最常見的字彙百科' },
        { id: 7875, text: '收錄最想學的日語會話' },
        { id: 7732, text: '把日語說得恰到好處' },
        { id: 6874, text: '帶你學好道地的日語' },
        { id: 6263, text: '日文閱讀初學最佳入門書' },
        { id: 7401, text: '追劇時別忘了學韓語' },
        { id: 6873, text: '最具代表性的韓國流行語' }
      ],
      bookData2: [
        { id: 7955, text: '多益達人教你應考秘技' },
        { id: 7456, text: '提升英語聽力的高效訓練' },
        { id: 7399, text: '用心智圖聰明背單字' },
        { id: 6779, text: '剖析多益解題關鍵' },
        { id: 7647, text: '用英語表達想法及提案' },
        { id: 7560, text: '各種通訊往來的英語都在' },
        { id: 7137, text: '精通職場情境的關鍵用語' },
        { id: 6835, text: '教你會議中常用英語對話' },
        { id: 8166, text: '讓你的英語跟上世界趨勢' },
        { id: 8009, text: '職場生活都派得上用場' },
        { id: 7012, text: '簡報日語馬上開口說' },
        { id: 6573, text: '理解日本職場文化' }
      ]
    }
  },
  mounted () {
    this.getEvent()
  },
  methods: {
    async getEvent () {
      let self = this
      await self.getData(self.bookData)
      await self.getData(self.bookData2)
    },
    getData (itemData) {
      let self = this
      let pathArr = []
      for (let i = 0; i < itemData.length; i++) {
        pathArr.push(itemData[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}&pageSize=20`)
        .then((response) => {
          response.data.data.map(item1 => {
            itemData.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })
        })
        .then(() => {
          self.forceRerender()
        })
    },
    forceRerender () {
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
    },
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#May2023 {
  .main-red-bg {
    background: #CC000C;
  }
  .main-red-pink {
    background: #ECC8CA;
  }
  .main-red-yellow {
    background: #FFF2B2;
  }
  .main-red-yellow2 {
    background: #FFD70E;
  }
  .main-red-color {
    color: #CC000C;
  }
  .circle {
    left: 5%;
    top: 0;
    width: auto;
    @media (max-width: 1024px) {
      left: 3%;
      top: -17%;
      width: 80%;
    }
    @media (max-width: 996px) {
      left: 0%;
      top: -17%;
      width: 70%;
    }
    @media (max-width: 767px) {
      left: 5%;
      top: -17%;
      width: auto;
    }
  }
  .toggle-btn {
    top: 20%;
    left: -40%;
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    right: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    right: -174px;
    transition: 0.3s;
  }
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .outer {
    position: relative;
    width: 100%;
    display: block;
    &:after {
      content: "";
      display: block;
      padding-Bottom: 70%;
    }
    .inner {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .section1 {
    position: relative;
    &:after {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 15%;
      width: 100%;
      content: "";
      z-index: 1;
      background: white;
      @media (max-width: 768px) {
        height: 10%;
      }
      @media (max-width: 425px) {
        height: 5%;
      }
    }
  }
}
</style>
